var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('popup-principal'),_c('back-button'),_c('router-view'),_c('footer-legal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }